"use client";

import { ArrowDown } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TermsHeader() {
  const eyebrow = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const word1 = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.3
  });
  const word2 = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.3
  });
  const word3 = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.3
  });
  const paragraph = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.3
  });
  const image = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const scrollIndicator = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  return <section data-section-id="3380" id="termsheader" className="relative min-h-screen w-full overflow-visible bg-background text-foreground">
      <div className="relative mx-auto flex min-h-screen max-w-[1440px] flex-col px-6 py-16 sm:px-10 lg:px-16 lg:py-20">
        {}
        

        {}
        <div className="relative grid flex-1 grid-cols-1 items-center gap-12 pt-16 lg:grid-cols-12 lg:gap-8 lg:pt-24">
          {}
          <div className="lg:col-span-7 lg:pr-8">
            <h1 className="font-default font-light leading-[0.95] tracking-tight text-foreground" style={{
            fontSize: "clamp(4rem, 8vw, 7rem)"
          }}>
              <span ref={word1.ref} className={`inline-block transition-all duration-[1200ms] ease-out ${word1.isVisible ? "opacity-100 translate-y-0 blur-0" : "opacity-0 translate-y-6 blur-md"}`}>
                Terms
              </span>{" "}
              <span ref={word2.ref} className={`inline-block italic font-normal transition-all duration-[1200ms] delay-150 ease-out ${word2.isVisible ? "opacity-100 translate-y-0 blur-0" : "opacity-0 translate-y-6 blur-md"}`}>
                &
              </span>{" "}
              <span ref={word3.ref} className={`inline-block transition-all duration-[1200ms] delay-300 ease-out ${word3.isVisible ? "opacity-100 translate-y-0 blur-0" : "opacity-0 translate-y-6 blur-md"}`}>
                Conditions.
              </span>
            </h1>

            <p ref={paragraph.ref} className={`mt-12 max-w-[480px] font-default text-base leading-relaxed text-muted-foreground transition-all duration-1000 delay-500 ease-out sm:text-lg ${paragraph.isVisible ? "opacity-100 translate-y-0 blur-0" : "opacity-0 translate-y-4 blur-sm"}`}>
              Transparency is the foundation of performance. Review our operational guidelines, research usage policies, and service standards to ensure a seamless experience with Iron Habit Peptides.
            </p>
          </div>

          {}
          <div className="lg:col-span-5 lg:relative">
            <div ref={image.ref} className={`relative mx-auto w-full max-w-md transition-all duration-[1400ms] ease-out lg:absolute lg:right-0 lg:top-12 lg:max-w-none lg:w-[110%] lg:translate-y-24 ${image.isVisible ? "opacity-100 translate-y-24 blur-0" : "opacity-0 lg:translate-y-32 translate-y-32 blur-md"}`}>
              <div className="overflow-hidden rounded-lg shadow-lg">
                
              </div>
              {}
              <div className="mt-4 flex items-center justify-between px-1">
                
                
              </div>
            </div>
          </div>
        </div>

        {}
        <div ref={scrollIndicator.ref} className={`relative mt-16 flex items-center gap-3 transition-all duration-1000 delay-700 ease-out lg:mt-auto lg:pt-16 ${scrollIndicator.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <ArrowDown className="h-3 w-3 text-primary animate-bounce" strokeWidth={1.5} />
          <span className="font-default text-[0.65rem] uppercase tracking-[0.25em] !text-[rgba(251,189,35,1)]">
            Scroll to Read
          </span>
        </div>
      </div>
    </section>;
}